import { render } from "./AddCategory.vue?vue&type=template&id=0377c472&scoped=true"
import script from "./AddCategory.vue?vue&type=script&lang=js"
export * from "./AddCategory.vue?vue&type=script&lang=js"

import "./AddCategory.vue?vue&type=style&index=0&id=0377c472&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0377c472"]])

export default __exports__